import { useState, useEffect, useRef } from "react";
import { HomeOutlined, FolderOpenOutlined, SettingOutlined, PlusCircleOutlined, SolutionOutlined, LeftCircleTwoTone } from "@ant-design/icons";
import { Col, Row } from "antd";
import { Translate } from "../translate";
import { getStore } from "../utils/global";
import { useParams } from "react-router-dom";

const PerMenu = ({ per, active, handleChange, name }) => {
  return (
    <a href={per.href} className="left_menu_per" active_color={active} onClick={() => handleChange && handleChange()}>
      <div className="left_menu_per_icon">{per.icon}</div>
      <div className="left_menu_per_name">{name}</div>
    </a>
  );
};

const LeftMenu = (props) => {
  const { main } = useParams();
  const [flipped, setFlipped] = useState(false);
  const isUnitel = window.location.hostname === "unitel.vsign.mn";
  const activeMenu = useRef("#/home");

  const hashchange = () => {
    let { hash } = window.location;
    if (hash.indexOf(activeMenu.current) === -1) {
      let exp = hash.split("/");
      activeMenu.current = `#/${exp[1]}`;
    }
  };

  const left_menus = [
    {
      key: 1,
      name: "home",
      active: "#/home",
      href: "#/home/0/0/0",
      icon: <HomeOutlined />,
    },
    {
      key: 2,
      name: "manage",
      active: "#/manage",
      href: "#/manage/0/0/0",
      icon: <FolderOpenOutlined />,
    },
    {
      key: 3,
      name: "settings",
      active: "#/settings",
      href: "#/settings/0/0/0",
      icon: <SettingOutlined />,
    },
    {
      key: 4,
      name: "drafts",
      active: "#/drafts",
      href: "#/drafts/0/0/0",
      icon: (
        <span>
          <SolutionOutlined />
        </span>
      ),
    },
  ];

  const handleNew = () => {
    let p = props.params;
    window.location.hash = `#/${p.main}/${p.mainfilter}/upload/0`;
  };

  const handleChange = () => {
    setFlipped(!flipped);
  };

  useEffect(() => {
    hashchange();
    window.addEventListener("hashchange", hashchange);
    return () => {
      window.removeEventListener("hashchange", hashchange);
    };
  }, []);

  let ln = typeof getStore("lang") === "object" ? "en" : getStore("lang");

  return (
    <>
      <div className="left_menu_hamburger">
        <div className="header" onClick={handleChange}>
          <Row>
            <Col style={{ paddingTop: "4%" }}>
              <LeftCircleTwoTone twoToneColor="#5E64FF" style={{ fontSize: "280%" }} />
            </Col>
            <Col>
              <img alt="vsign_logo" src="/logo.png" className="mobile_logo" />{" "}
            </Col>
          </Row>
        </div>
      </div>
      <div
        className="mobile_header_overlay"
        style={{
          transform: `translateX(${flipped ? "0" : "-100%"})`,
        }}>
        <div onClick={handleChange} className="mobile_close_x">
          X
        </div>
        <div className="mobile_overlay_item">
          <div className="btn button_flex" bg_color="5" onClick={handleNew}>
            {Translate[ln].Main.new} <PlusCircleOutlined />
          </div>
        </div>
        {left_menus.map((per, i) => (
          <PerMenu key={per.key} per={per} active={main === per.name ? 1 : 0} handleChange={handleChange} name={Translate[ln].Main[[per.name]]} />
        ))}
      </div>
      <div className="left_menu">
        <div className="header">
          <div className="header_logo">
            <img src="/logo.png" alt="logo" />
            <div className="header_logo_name">VSIGN</div>
            {isUnitel && <img src="/unitel.svg" alt="unitel" style={{ marginLeft: 30, height: 30 }} />}
          </div>
        </div>
        <div className="left_menu_container">
          <div className="left_menu_button">
            <div className="btn button_flex" bg_color="5" onClick={handleNew}>
              {Translate[ln].Main.new} <PlusCircleOutlined />
            </div>
          </div>
          {left_menus.map((per, i) => (
            <PerMenu key={per.key} per={per} active={main === per.name ? 1 : 0} name={Translate[ln].Main[[per.name]]} />
          ))}
        </div>
      </div>
    </>
  );
};

export default LeftMenu;
